<template>
  <div class="loginBox">
    <div class="bannerBox">
      <div class="titleBox">
        <img src="../assets/images/LOGOs.png" alt="" style="height:43px">
        <p>生物医疗销售全流程管理系统&nbsp;&nbsp; |&nbsp;&nbsp; 密码重置</p>
      </div>
      <div class="login">
        <div class="right">
          <!--<div class="title">密码重置</div>-->
          <div class="logins">
            <h3>密码复杂度规范：</h3>
            <h6>1、新密码长度不能小于10位；</h6>
            <h6>2、必须包含大写字母、小写字母、数字和特殊符号中的三项，且无键盘连续字母、字符、数字；</h6>
            <h6>3、不能包含用户的账户名 例如：张三、zhangsan；</h6>
            <h6>4、不能包含应用名称 例如：iHaier、portal；</h6>
            <h6>5、不能包含公司名称和业务关键字，例如：haier、cosmoplat、rrswl；</h6>
            <h6>6、不能包含超过3位的连续数字、连续字母、重复数字或重复字母，例如：1234、abcd、1111、aaaa；</h6>
          </div>
          <div class="logins">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input user">
              <el-form-item label="请输入旧密码" prop="oldPassword" class="box">
                <el-input class="phone" type="password" v-model="ruleForm.oldPassword" autocomplete="off"
                          clearable
                          placeholder="请输入旧密码"></el-input>
              </el-form-item>
              <el-form-item label="设置新密码" prop="password" class="box">
                <el-input class="phone" type="password" v-model="ruleForm.password" autocomplete="off"
                          clearable
                          placeholder="设置密码"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="checkPassword" class="box">
                <el-input class="phone" type="password" v-model="ruleForm.checkPassword" autocomplete="off"
                          clearable
                          placeholder="确认密码"></el-input>
              </el-form-item>
            </el-form>
            <div style="display: flex;justify-content: center;align-items: center;margin-top: 0.6rem">
              <el-button style="width: 1rem" @click="back">返回</el-button>
              <el-button type="primary" style="width: 1rem" @click="comment('ruleForm')">提交</el-button>
            </div>
          </div>
          <div v-if="indx==1" class="checkingBox">
            {{msg}}
            <div v-if="show" style="margin-top: 20px; font-size: 18px;">
              将在<span style="font-size: 20px;color: #ff2424;">{{count}}秒</span>后跳转至登录页
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="bottoms">
      Copyright Haier 2019. All rights reserved
    </div>
  </div>
</template>

<script>
import ss from '../api/SystemService'

function checkPassword(pwd) {
  var len = pwd.length;
  var flag = true;
  for (var i = 1; i < len-3; i++) {
    var firstIndex = pwd.charCodeAt(i-1);
    var secondIndex = pwd.charCodeAt(i);
    var thirdIndex = pwd.charCodeAt(i+1);
    var fourthIndex = pwd.charCodeAt(i+2);

    if((fourthIndex - thirdIndex == 1)&&(thirdIndex - secondIndex == 1)&&(secondIndex - firstIndex==1)){
      flag =  false;
    }
  }
  return flag;

}

function validateKey(str) {
  //定义横向穷举
  var keyCode = [
    ["`~·", "1=", "2@@", "3#", "4$￥", "5%", "6^……", "7&", "8*", "9(（", "0）)", "-_", "=+"],
    [" ","qQ", "wW", "eE", "rR", "tT", "yY", "uU", "iI", "oO", "pP", "[{【", "]}】", "\\|、"],
    [" ","aA", "sS", "dD", "fF", "gG", "hH", "jJ", "kK", "lL", ";:", "\'\"’“"],
    [" ","zZ", "xX", "cC", "vV", "bB", "nN", "mM", ",《<", ".>》", "/?？"]
  ];

  //找出给出的字符串，每个字符，在坐标系中的位置。
  var c = str.split("");
  var x = new Array();
  var y = new Array();
  for (var i = 0; i < c.length; i++) {
    var temp = c[i];
    toHere:
            for (var j = 0; j < keyCode.length; j++) {
              for (var k = 0; k < keyCode[j].length; k++) {
                var jk = keyCode[j][k];
                if (jk.indexOf(temp)!=-1) {
                  x.push(j);
                  y.push(k);
                  break toHere;
                }
              }
            }
  }
  var flag = false;
  for (var i = 0; i < x.length - 2; i++) {
    // 如果X一致，那么就是在一排
    if (x[i] == x[i + 1] && x[i + 1] == x[i + 2]) {//四者在同一行上
      if (y[i] > y[i + 2]) {
        if (y[i] - 1 == y[i + 1] && y[i] - 2 == y[i + 2]) {
          flag = true;
          break;
        }
      } else {
        if (y[i] + 1 == y[i + 1] && y[i] + 2 == y[i + 2]) {
          flag = true;
          break;
        }
      }
    } else if (x[i] != x[i + 1]
            && x[i + 1] != x[i + 2]
            && x[i] != x[i + 2]
    ) {//四者均不在同一行上,但是如果y相同，说明是一列
      if (y[i] == y[i + 1] && y[i + 1] == y[i + 2]) {
        flag = true;
        break;
      }
    }
  }
  return flag;
}
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        var reg1 = /((^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[^A-Za-z0-9])[\da-zA-Z_\W]{10,}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z_\W]{10,}$))/;
        var reg2 = /([a-zA-Z0-9])\1{3}/;
        var reg3 = /(iHaier|portal)/;
        if (!reg1.test(value)) {
          callback(new Error("密码必须是10位以上,必须含有大写字母、小写字母、数字、特殊符号中的三项"));
        } else if (reg2.test(value)) {
          callback(new Error("不能包含超过3位的重复数字或字母"));
        } else if (!checkPassword(value)) {
          callback(new Error("不能包含超过3位的连续数字或字母"));
        } else if (validateKey(value)){
          callback(new Error("不能包含键盘连续的字母,符号和数字"));
        } else if (reg3.test(value)){
          callback(new Error("不能包含应用名称"));
        } else {
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      count:30,
      show:false,
      indx:0,
      ucode: '',
      ruleForm: {
        oldPassword: '',
        password: '',
        checkPassword: '',
      },
      rules: {
        oldPassword:
            [
              {required: true, message: '请填写必填项', trigger: 'blur'},
            ],
        password:
            [
              {required: true, validator: validatePass, trigger: 'blur'},
            ],
        checkPassword:
            [
              {required: true, validator: validatePass2, trigger: 'blur'},
            ],
      },
    }
  },
  created() {
    console.log(this.$route.query);
    this.ucode = this.$route.query.user.trim();
  },
  methods: {
    //3秒后进入跳转页面
    threeGo(){
      console.log(1)
      const TIME_COUNT = 3;
      if(!this.timer){
        this.count = TIME_COUNT;
        this.show = true;
        this.timer = setInterval(()=>{
          if(this.count > 0 && this.count <= TIME_COUNT){
            this.count--;
          }else{
            clearInterval(this.timer);
            this.timer = null;
            this.show = false;
            // //跳转的页面写在此处
            this.$router.push('login');
          }
        },1000)
      }
    },
    // 提交按钮功能
    comment(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          if (this.ruleForm.password != null) {
            ss.ResetPassService.resetUserPass(this.ruleForm.oldPassword,this.ucode,this.ruleForm.password).then(rd => {
              if(rd.f){
                this.$msg.msgs(rd.msg)
                this.indx=1;
                this.msg=rd.msg;
                this.show = true;
                this.threeGo()
              }else{
                this.$msg.msge(rd.msg)
              }
            })
          }
        } else {
          this.$msg.msge("请完善信息后再提交！");
          return false;
        }
      });
    },
    // 返回按钮功能
    back() {
      this.$router.push("/login");
    },
  },
  mounted() {

  }
}
</script>

<style scoped>
.box {
  display: flex;
}

.loginBox {
  width: 100%;
  height: 100%;
  background: url(../assets/images/login-bg.jpg)
}

.bannerBox {
  width: 1100px;
  margin: 0 auto;
}

.titleBox {
  padding-top: 30px;
  display: flex;
}

.titleBox p {
  font-size: 30px;
  color: #ffffff;
  padding: 0;
  margin: 0;
  line-height: 50px;
  margin-left: 38px;
}

.login {
  width: 100%;
  display: flex;
  margin-top: 28px;
  margin-bottom: 0.5rem;
}

.login .right {
  width: 100%;
  height: 100%;
  padding: 0 0 1rem 0;
  background: #fff;
  position: relative;
  border-radius: 0 8px 8px 0px;
}


.login .right .title {
  margin-top: 1rem;
  text-align: center;
  font-size: 24px;
  color: #128bf1;
}

.logins {
  width: 80%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin: 0 auto;
  margin-top: 1rem;
}

.bottoms {
  background: #000;
  width: 100%;
  height: 53px;
  text-align: center;
  line-height: 53px;
  font-size: 14px;
  color: #a4a4a4;
}

.checkingBox{
  padding: 0 44px 0 174px;
  margin-top: 20px;
  font-size: 18px;
}
</style>
<style>
.box .el-form-item__label {
  width: 15%;
}

.box .el-form-item__content {
  width: 90%;
}

.ljjregmima .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 37%;
}

.ljjregmima .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 63%;
}

.ljjregmima .h-formbLine .h-elformWrap-2 .el-form-item__label {
  width: 84%;
}

.ljjregmima .h-formbLine .h-elformWrap-2 .el-form-item__content {
  width: 16%;
}
</style>